import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useTheme } from 'next-themes'
import { sendEvent } from '@/utils/gtag'
import InstagramIcon from '@/components/icons/instagram'
import TwitterIcon from '@/components/icons/twitter'

const catList = [
  { slug: 'producer', name: 'プロデューサー' },
  { slug: 'singer', name: 'シンガー' },
  { slug: 'arranger', name: 'アレンジャー' },
  { slug: 'composer', name: '作曲家' },
  { slug: 'mixing-engineer', name: 'ミックスエンジニア' },
]

const Footer = () => {
  const { setTheme } = useTheme()

  const handleClick = () => {
    sendEvent({ event: 'professional_search', origin: 'footer' })
  }

  return (
    <footer className="dark:bg-black/85 flex items-center bg-black/90 py-20 transition-colors">
      <div className="container my-10 justify-center lg:my-0 lg:flex">
        <div className="mb-4 lg:mb-0 lg:w-45p lg:px-4 lg:pl-12">
          <div className="mb-6 md:mb-7">
            <Link href="/">
              <Image
                className="w-55"
                src="/images/logo-inverse.svg"
                alt="ONLIVE Studio"
                width="220"
                height="44"
              />
            </Link>
          </div>
          <p className="mb-0 text-xs text-gray-footer">
            (C) SOUND ON LIVE, Inc. with a whole lot of ♥
          </p>
          <div className="flex items-center gap-4 pt-8 pb-2">
            <a
              href="https://www.instagram.com/onlive.studio/"
              className="rounded-full border border-white/30 p-4 hover:bg-black"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Instagram（新しいタブで開く）"
            >
              <InstagramIcon className="h-4 w-4 fill-white" />
            </a>
            <a
              href="https://twitter.com/onlivestudio"
              className="rounded-full border border-white/30 p-4 hover:bg-black"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="X（旧Twitter、新しいタブで開く）"
            >
              <TwitterIcon className="h-4 w-4 fill-white" />
            </a>
          </div>
          <div className="py-2">
            <Link
              href="https://blog.onlive.studio/"
              target="_blank"
              rel="noreferrer noopener"
              className="block py-4 text-sm text-slate-100 hover:underline"
            >
              音楽制作に携わる人へ贈る情報メディア
              <br />
              <strong className="text-base">「ONLIVE Studio blog」</strong>
            </Link>
          </div>
        </div>
        <div className="lg:w-55p">
          <nav className="md:flex">
            <ul className="mb-0 md:mr-4 lg:mr-20">
              <li>
                <Link
                  href="/search"
                  className="mb-4 block leading-loose text-slate-100 hover:underline"
                  onClick={handleClick}
                >
                  クリエイターを探す
                </Link>
              </li>
              {catList.map((cat) => (
                <li key={cat.slug} className="my-2">
                  <Link
                    href={`/cat/${cat.slug}`}
                    className=" py-2 text-xs leading-loose text-slate-300 hover:underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li className="my-2">
                <Link
                  href="/search"
                  className="py-2 text-xs leading-loose text-slate-300 hover:underline"
                >
                  すべてのカテゴリー
                </Link>
              </li>
              <li>
                <Link
                  href="/register-pro"
                  className="block py-4 text-slate-100 hover:underline"
                >
                  クリエイターへ登録する
                </Link>
              </li>
            </ul>
            <div className="hr !border-slate-600 md:hidden" />
            <ul className="mb-12 leading-loose md:mr-4 md:mb-0 lg:mr-20">
              <li>
                <Link
                  href="/terms"
                  className="mb-2 block text-slate-100 hover:underline"
                >
                  利用規約
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="mb-2 block text-slate-100 hover:underline"
                >
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link
                  href="/company"
                  className="mb-2 block text-slate-100 hover:underline"
                >
                  運営会社について
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="mb-2 block text-slate-100 hover:underline"
                >
                  お問い合わせ
                </Link>
              </li>
              <li>
                <a
                  href="https://support.onlive.studio/"
                  className="mb-2 block text-slate-100 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  サポートセンター
                </a>
              </li>
            </ul>
          </nav>
          <div className="flex justify-end">
            <div className="relative flex gap-3 rounded-full border border-slate-600 p-1">
              <div className="absolute h-8 w-8 rounded-full bg-slate-600 transition-all dark:translate-x-11" />
              <button
                type="button"
                className="btn-chromeless relative block rounded-full p-2"
                onClick={() => setTheme('light')}
              >
                <Image
                  className="h-4 w-4"
                  src="/images/icons/sun.svg"
                  width="16"
                  height="16"
                  alt="light mode"
                />
              </button>
              <button
                type="button"
                className="btn-chromeless relative block rounded-full p-2"
                onClick={() => setTheme('dark')}
              >
                <Image
                  className="h-4 w-4"
                  src="/images/icons/moon.svg"
                  width="16"
                  height="16"
                  alt="light mode"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
